<template>
  <div class="page-node" :class="`page-type-${nodeType}`" ref="articlePage">
    <svg xmlns="http://www.w3.org/2000/svg" class="sr-only">
      <def>
        <filter id="blur-effect--20">
          <feGaussianBlur edgeMode="duplicate" stdDeviation="20"></feGaussianBlur>
          <feComponentTransfer>
            <feFuncA tableValues="1 1"/>
         </feComponentTransfer>
        </filter>
      </def>
    </svg>
    <CusCarousel :sliderOptions="sliderOptions" selector="slider-1" ref="cusCarousel" @slideProgress="slideProgress"
                 @slideChangeEnd="slideChangeEnd" @slideChangeStart="slideChangeStart" class="article-carousel" :extraSlots="carouselExtraSlots">
      <widget-share-buttons
        v-show="!relatedPersonOverlay.toggle"
        :class="['articleView__shareButtons', 'hidden-sm-up', shareBarActive, shareBarNoAnimation ? 'no-animation': '', {inCard}]"
        mode="sticky"
        ref="shareButtons"
        :url="shareData.url"
        :shortenUrl="shareData.shortenUrl"
        :title="shareData.title"
        :thumbnail="shareData.thumbnail"
        gtmType="gtmType_shareBtn-adhesiveBar"
        slot="sharebar"
      ></widget-share-buttons>
      <div class='slider-pagination' slot="pagination"></div>
      <div class="article-view-wrapper slider-panel scroll-x-hidden" :data-nid="articleNID" v-for="(articleNID, key) in articleList" :key="key" :class="{active: isActive(articleNID), touchtopbottom: reachTopBottom, preventScroll: preventScroll}" :ref="getWrapperRef(articleNID)">

        <h1 v-if="showSeoTitle && node.title" class="news-title">{{node.title}}</h1>

        <!--previous card begin-->
        <div v-if="prevArticleNID && activeNID == articleNID && showPrevCardCover" v-show="showTopCover" class="prevCardCover" :style="{'margin-top': `${prevCardMargintop}px`, height: `${viewportHeight}px`, transform: `translateY(${prevCardTransformY}px)`}" :class="{reset: cardReset, animate: cardAnimate}">
          <card-cover :isHideAnimationElement="true" :nid="prevArticleNID"
                      :showVideoPlayButton="false"
                      :ref="getCoverRef(prevArticleNID)"
                      :class="{active: isActive(prevArticleNID)}"
                      class="cardInvisible"></card-cover>
        </div>
        <!--previous card end-->

        <template v-if="articleNID === activeNID || remainPosition(articleNID)">
          <template v-if="articleNID === activeNID && showTopCover && !remainPosition(articleNID)">
            <card-cover cardPosition="top" @cardMounted="cardMounted" :showVideoPlayButton="showVideoPlayButton" :actionToggle="cardActionAnimate"  :isHideAnimationElement="!(articleNID === activeNID)" :nid="articleNID" :ref="getCoverRef(articleNID)" :class="{active: isActive(articleNID), 'to-top': atTop && showTopCover, bounce: bounce, reset: cardReset}" :style="{'margin-top': cardMargintop + 'vh'}">
              <div slot="arrowsHover" ref="arrowsHoverWrapper" class="arrowsHover hidden-sm-down row">
                <div class="left-area arrow-block" ref="arrowsHover" @mouseover="forceShowArrows('left')"></div>
                <div class="center-area arrow-block" @mouseenter="forceHideArrows"></div>
                <div class="right-area arrow-block" ref="arrowsHover" @mouseover="forceShowArrows('right')"></div>
                <div class="card-middle"></div>
              </div>
            </card-cover>
          </template>
          <div :style="{height: bodyMaxHeight}" :class="{bounce: bounceBottom, 'with-card-video': isShowVideo[articleNID], bodyFadeIn: bodyFadeIn}" class="article-body-card-wrapper vw-100"
               :ref="getBodyCardWrapperRef(articleNID)">
            <div class="card-video-container" ref="cardVideoContainer">
              <card-video :class="{show: isShowVideo[articleNID], hide: !isShowVideo[articleNID]}" :ref="cardVideoNID" :nid="activeNID"  :autoStart="videoAutoStart()" :showCusPlayButton="true"  :bindOnAction="bindVideoAction" :parentActionOnHide="actionOnVideoHide" class="no-article-swipe"></card-video>
            </div>
            <node-body :style="{'margin-top': bodyMarginTop + 'vh'}" v-show="showNodeBody"
                       :class="{reset: bottomCardReset, 'bounce-bottom': bounceBottom}" :nid="articleNID"
                       :ref="getArticleRef(articleNID)">
            </node-body>

            <div class="arrow-down-wrapper" :class="articleType" v-if="arrowNext && nextArticleNID" v-show="showNodeBody">
              <div class="bottom-divider" ref="bottomDivider"></div>
              <svg-icon-arrow-down-one></svg-icon-arrow-down-one>
            </div>
            <div class="next-article-indication" v-if="nextArticleNID">
              <div class="hidden-sm-up coming-next">and now<br>this</div>
              <div class="bottom-card-invader hidden-sm-up"><icon-bottom-card-invader></icon-bottom-card-invader></div>
            </div>

            <monster-newsletter-form-desktop v-show="showNodeBody"
              ref="monsterNewsletter"
              class="monster-newsletter-widget hidden-sm-down"
              slot="content"
              :sections="node.sections"
              gtmType="gtmType_newsletter-footer"
              >
            </monster-newsletter-form-desktop>

            <div class="article-bottom-card-wrapper" v-if="nextArticleNID && activeNID == articleNID" ref="articleBottomCardWrapper" v-show="showNodeBody">
              <card-cover v-show="showBottomCover" :isHideAnimationElement="true" :nid="nextArticleNID" :showAction="false"
                          :showVideoPlayButton="false"
                          :ref="getCoverRef(nextArticleNID)"
                          :class="{active: isActive(nextArticleNID), fullHeight: !bottomBlankSpace, 'smooth-animate': bottomCardSmoothAnimate}"
                          cardPosition="bottom"
                          class="cardInvisible bottom-card"
                          :style="{transform: `scale(${bottomCardScale}) translate3d(0,0,0) translateZ(0)`, 'transform-origin': 'top center'}"></card-cover>
              <div class="bottom-card-cover-blank-space hidden-xs-down" ref="bottomCardBlankSpace" v-if="bottomBlankSpace">
                <div class="scroll-to-continue">Scroll to continue</div>
                <div class="scroll-down-arrow"><svg-arrow-down width="100%" height="100%"></svg-arrow-down></div>
              </div>
              <div class="header_text text-center">{{nextCoverHeaderText}}</div>
            </div>

            <template v-if="key === articleList.length - 1 && !nextArticleNID">
              <tech-lift-footer logo showTopicList theme="footer-red" iconColor="rgba(220, 58, 53, 1)" class="vw-100" gtm-event-category="Footer"></tech-lift-footer>
            </template>
          </div>
        </template>
        <template v-else-if="lazyCover(key)">
          <card-cover :isHideAnimationElement="showVideoPlayButton" :showVideoPlayButton="true" :nid="articleNID" cardPosition="lazy"></card-cover>
          <div class="card-cover-blank-space hidden-xs-down"></div>
        </template>
      </div>
    </CusCarousel>

    <related-person-overlay-header class="related-person-overlay-header" v-if="hasRelatedPersonInBody" :theme="currentViewPort" :nid="relatedPersonOverlay.nid" :overlayBody="this.$refs.relatedPersonOverlay" :class="{'hidden-right': !relatedPersonOverlay.toggle, 'showing-desktop-header': showDesktopHeaderMenu}" width="640px"></related-person-overlay-header>

    <div class="related-person-overlay-layer" v-if="hasRelatedPersonInBody && relatedPersonOverlay.toggle" :class="[{'hidden-right': !relatedPersonOverlay.toggle}, `theme-${currentViewPort}`]"></div>
    <div class="related-person-overlay" v-if="hasRelatedPersonInBody" :class="[{'hidden-right': !relatedPersonOverlay.toggle, 'showing-desktop-header': showDesktopHeaderMenu}, `theme-${currentViewPort}`]">
      <related-person-overlay ref="relatedPersonOverlay" :overlay="true" :showingOverlay="relatedPersonOverlay.toggle" :nid="relatedPersonOverlay.nid" class="overlay" :theme="currentViewPort"></related-person-overlay>
    </div>

    <related-person-overlay-share-bar :class="{'hidden-right': !relatedPersonOverlay.toggle}" v-if="hasRelatedPersonInBody" :theme="currentViewPort" :nid="relatedPersonOverlay.nid" :overlayBody="this.$refs.relatedPersonOverlay"></related-person-overlay-share-bar>

    <div class="arrow-prev article-arrow" ref="articleArrowLeft" @click="prevArticle()" :style="newArrowTopPercentage" v-show="arrowPrev && (arrowInit || hoverCover)" :class="{arrowFadeIn: arrowVisible, onCover: hoverCover}"><icon-arrow-left width="70" height="70"></icon-arrow-left></div>
    <div class="arrow-next article-arrow" ref="articleArrowRight" @click="nextArticle()" :style="newArrowTopPercentage" v-show="arrowNext && (arrowInit || hoverCover)" :class="{arrowFadeIn: arrowVisible, onCover: hoverCover}"><icon-arrow-right width="70" height="70"></icon-arrow-right></div>
    <div class="fixed-bottom">
      <div class="newsletter hidden-sm-up" v-if="allowNewsletterWidgetPopup" :style="{'left': newsLetterWidgetXPadding + 'px'}">
        <pop-up-wrapper>
          <monster-newsletter-form slot="content" :sections="node.sections" gtmType="gtmType_newsletter-adhesive"></monster-newsletter-form>
        </pop-up-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

  import CusCarousel from 'components/custom-carousel/CusCarousel.vue'
  import NodeBody from 'components/node/NodeBody.vue'
  import CardCover from 'components/node/CardCover.vue'
  import mixinSection from 'components/mixins/section'
  import navHeaderMobile from 'components/mixins/navHeaderMobile'
  import navHeaderDesktop from 'components/mixins/navHeaderDesktop'
  import animationHandler from 'components/mixins/animationHandler'
  import GTMManager from 'mixins/gtm-manager'
  import EventBus from 'components/helpers/event-bus'

  import get from 'lodash/get'
  import map from 'lodash/map'
  import forEach from 'lodash/forEach'
  import indexOf from 'lodash/indexOf'
  import toInteger from 'lodash/toInteger'
  import unionBy from 'lodash/unionBy'
  import isEmpty from 'lodash/isEmpty'
  import find from 'lodash/find'
  import has from 'lodash/has'
  import isBoolean from 'lodash/isBoolean'
  import last from 'lodash/last'
  import throttle from 'lodash/throttle'
  import isFunction from 'lodash/isFunction'
  import xor from 'lodash/xor'
  import values from 'lodash/values'

  import {
    supportPassive,
    isDesktop,
    isTablet,
    getArticleType,
    isDomElement,
    bindInputForAndroid,
    unbindInputForAndroid,
    isIOS,
    getNodeQueueTid,
    updateTitleByNodeType,
  } from 'mixins/utilities'

  import PopUpWrapper from 'components/common/PopUpWrapper.vue'
  import WidgetShareButtons from 'components/widgets/ShareButtons.vue'
  import MonsterNewsletterForm from 'components/widgets/MonsterNewsletterForm.vue'
  import MonsterNewsletterFormDesktop from 'components/widgets/MonsterNewsletterFormDesktop.vue'
  import CardVideo from 'components/node/CardVideo.vue'
  import RelatedPersonOverlay from 'components/node/person/PersonBody.vue'
  import RelatedPersonOverlayHeader from 'components/node/person/Header.vue'
  import RelatedPersonOverlayShareBar from 'components/node/person/ShareBar.vue'

  import SvgVideoPlayIcon from 'static/svg/raw/icon_videoplay.svg'
  import IconArrowLeft from 'static/svg/icon_arrow_left.svg'
  import IconArrowRight from 'static/svg/icon_arrow_right.svg'
  import SvgIconArrowDownOne from 'static/svg/icon_arrow_down1.svg'
  import SvgArrowDown from 'static/svg/icon_arrow_down.svg'
  import IconBottomCardInvader from 'static/svg/icon_bottom_card_invader.svg'

  const articleLimit = 10

  export default {
    name: 'article-view',
    props: ['nid'],
    mixins: [mixinSection, navHeaderMobile, navHeaderDesktop, animationHandler],
    components: {
      NodeBody,
      CardCover,
      CusCarousel,
      WidgetShareButtons,
      MonsterNewsletterForm,
      MonsterNewsletterFormDesktop,
      PopUpWrapper,
      CardVideo,
      SvgVideoPlayIcon,
      IconArrowLeft,
      IconArrowRight,
      SvgIconArrowDownOne,
      SvgArrowDown,
      RelatedPersonOverlay,
      RelatedPersonOverlayHeader,
      RelatedPersonOverlayShareBar,
      IconBottomCardInvader,
      TechLiftFooter: () => import('components/app-shell/TechLiftFooter.vue'),
    },
    created () {
      this.setActiveNID(this.nid)
    },
    data() {
      return {
        sliderOptions: {
          allowScroll: true,
          realTimeAnimate: true,
          sensitivity: 15, // swipe over percentage of screen eg. 25% / 50% / 80%
          exactAngle: [{
            min: -20,
            max: 20,
            abs: true,
          }, {
            min: 160,
            max: 180,
            abs: true,
          }],
          childScrolling: false,
          setScrolling: false,
          childProcessed: false,
          forceStop: false,
          disableSwipe: true,
          articleLimit,
          initFromMount: false,
        },
        articleList: [this.nid],
        articleListLimit: articleLimit,
        articleListOffset: 0,
        atTop: false,
        nextCard: false,
        showTopCover: true,
        showPrevCardCover: false,
        touchTimeStamp: 0,
        touchStartX: 0,
        touchStartY: 0,
        cardMargintop: 0,
        prevCardMargintop: 0,
        prevCardTransformY: 0,
        inCard: true,
        touching: false,
        bounce: false,
        bounceBottom: false,
        cardReset: false,
        cardAnimate: false,
        bottomCardReset: false,
        bodyMarginTop: 0,
        bodyMaxHeight: 'auto',
        nextBybottom: false,
        lastPosition: {},
        lastScrollPosition: 0,
        isVideoFullScreen: false,
        bindVideoAction: {
          fullscreen: this.actionOnVideoFullScreen,
          pause: this.actionOnVideoPause,
          idle: this.actionOnVideoIdle,
          play: this.actionOnVideoPlay,
        },
        reachTopBottom: false,
        newsletterCheckCount: 0,
        currentViewPort: false,
        shareBarActive: 'hide',
        shareBarNoAnimation: false,
        shareBarWaitForActive: false,
        allowHeaderToggle: true,
        isShowVideo: {},
        showVideoPlayButton: false,
        newsLetterWidgetXPadding: 0,
        nextPrevByArrow: false,
        arrowPrev: false,
        arrowNext: true,
        arrowVisible: false,
        arrowInit: false,
        newArrowTopPercentage: {},
        slideChanging: false,
        articleScrollY: 0,
        hoverCover: false,
        showCoverArrowOnce: true,
        hideVideoPromise: undefined,
        pageScroll: true,
        pageScrollCounter: false,
        bodyFadeIn: false,
        scrollEnd: true,
        scrollTimer: '',
        preventPan: false,
        allowSwipePrevCard: false,
        initCarousel: false,
        disableCardAnimate: false,
        showNodeBody: true,
        listenWheel: false,
        isCardMounted: false,
        isBodyMounted: false,
        bottomBlankSpace: false,
        carouselExtraSlots: [{
          key: 'sharebar',
          animationClass: 'share-buttons-wrapper',
        }],
        bottomCardScale: 1,
        initBottomCardScale: 0.3,
        showBottomCover: true,
        allowNextByBottom: true,
        touchSpeed: false,
        bottomCardSmoothAnimate: false,
        firstScrollTimeStamp: false,
        firstScrollPos: false,
        cardActionAnimate: false,
        scrollToTopFlag: false,
        preventScroll: false,
        showSeoTitle: true,
      }
    },
    computed: {
      ...mapState([
        'nodes',
        'scaleHeaderBar',
        'nodeHeader',
        'nodeQueue',
        'viewportHeight',
        'showNewsletter',
        'activeNID',
        'relatedPersonOverlay',
        'articleListTid',
        'showDesktopHeaderMenu',
        'allowNewsletterWidgetPopup',
        'isRefreshedToRoutedArticle',
      ]),
      node() {
        return this.$store.getters.node(this.activeNID)
      },
      nodeType() {
        return get(this, 'node.type', 'article')
      },
      shareData() {
        const obj = {
          url: `${this.requestDomain()}${get(this.node, 'relative_url', '')}`,
          shortenUrl: get(this.node, 'shorten_url', ''),
          title: updateTitleByNodeType({type: get(this, 'node.type', ''), originalTitle: get(this.node, 'title', '')}),
          thumbnail: get(this, 'node.images[0].style_700x400'),
        }
        return obj
      },
      articleType() {
        return getArticleType(this.node)
      },
      firstRelatedPerson() {
        return get(this, 'node.related_people[0].nid')
      },
      hasRelatedPersonInBody() {
        return find(get(this, 'node.contentList', []), ['type', 'person'])
      },
      fetchNodeQueueFromLiftigniter() {
        return get(this.settings(), 'LIFTIGNITER.RECOMMENDATION', false) && this.isLiftigniterInit()
      },
      articleCover: {
        cache: false,
        get() {
          return get(this, `$refs[${this.getCoverRef(this.activeNID)}]`, false)
        },
      },
      articleBody: {
        cache: false,
        get() {
          return get(this, `$refs[${this.getArticleRef(this.activeNID)}]`, false)
        },
      },
      articleBodyCardWrapper: {
        cache: false,
        get() {
          return get(this, `$refs[${this.getBodyCardWrapperRef(this.activeNID)}]`, false)
        },
      },
      nextArticleCover: {
        cache: false,
        get() {
          return get(this, `$refs[${this.getCoverRef(this.nextArticleNID)}]`, false)
        },
      },
      articleWrapper: {
        cache: false,
        get() {
          return get(this, `$refs[${this.getWrapperRef(this.activeNID)}][0]`, [])
        },
      },
      nextArticleNID: {
        cache: false,
        get() {
          if (indexOf(this.articleList, this.activeNID) < (get(this, 'articleList.length', 0) - 1)) {
            return this.articleList[indexOf(this.articleList, this.activeNID) + 1]
          }
          return false
        },
      },
      prevArticleNID: {
        cache: false,
        get() {
          if (indexOf(this.articleList, this.activeNID) > 0 && get(this, 'articleList.length', 0) > 1) {
            return this.articleList[indexOf(this.articleList, this.activeNID) - 1]
          }
          return false
        },
      },
      cardVideoNID() {
        return `cardVideo-${this.activeNID}`
      },
      sections() {
        const sections = []
        forEach(get(this, 'node.sections', []), (sectionLineage) => {
          const sectionList = map(sectionLineage, this.$store.getters.term)
          sections.push(sectionList)
        })
        return sections
      },
      nextCoverHeaderText() {
        if (get(this, 'nextArticleNID')) {
          const nextNode = this.$store.getters.node(get(this, 'nextArticleNID'))

          if (get(nextNode, 'sections')) {
            return get(this.getLastSection(get(nextNode, 'sections')), 'name', '')
          }
        }
        return ''
      },
      viewPortHeightVh() {
        if (typeof window !== 'undefined') {
          return (window.innerHeight / this.viewportHeight) * 100
        }
        return 100
      },
      cardVideoContainer: {
        cache: false,
        get() {
          return get(this, '$refs.cardVideoContainer', false)
        },
      },
      videoCard() {
        return get(this, `$refs.${this.cardVideoNID}[0]`, {})
      },
      cardCoverIsVideo: {
        cache: false,
        get() {
          return get(this, 'node.isCardVideo', false)
        },
      },
      cardCoverVideoOrientation: {
        cache: false,
        get() {
          return get(this, 'node.videoOrientation', '')
        },
      },
    },
    beforeMount() {
      EventBus.$on('bodyMounted', () => {
        this.bodyMounted()
      })
      this.setHeaderTitle(get(this, 'firstSectionLineage', []))
      this.innerHeight = require('ios-inner-height')
    },
    mounted() {
      this.showSeoTitle = false
      this.$store.commit('setIsRefreshedToRoutedArticle', false)
      bindInputForAndroid(this.articleWrapper)
      this.showCoverArrowsOnce(3000)
      this.resetMobileHeader()
      this.resetDesktopHeader()
      this.shareButtons = this.$refs.shareButtons.$el
      this.bindTopCoverTouchSupport()
      this.bindVidoeCardConatinerTouchSupport()
      this.bindBodyTouchSupport()
      this.bindBottomCoverTouchSupport()
      this.handleViewportChange()
      this.currentViewPort = isDesktop() ? 'desktop' : 'mobile'
      this.sliderOptions.disableSwipe = isDesktop()
      this.showVideoPlayButton = true
      this.isShowVideo[this.activeNID] = (!isDesktop() && this.cardCoverIsVideo)
      if (!isDesktop()) {
        this.showPrevCardCover = true
        this.allowSwipePrevCard = true
        this.prevCardMargintop = this.viewportHeight * -1
        this.prevCardTransformY = (this.viewportHeight - (this.viewportHeight * (this.viewPortHeightVh / 100)))
        this.bottomCardScale = this.initBottomCardScale
      }
      EventBus.$emit('liftigniter-SendPageView')

      this.fetchArticleList(true, this.fetchNodeQueueFromLiftigniter)
    },
    methods: {
      ...mapActions([
        'toggleHeaderBar',
        'setHeaderTitle',
        'toggleNewsletter',
        'enableNewsletterWidgetPopup',
        'setActiveNID',
        'setDesktopReadingPosition',
        'enableLandscapeBlock',
        'toggleHeaderTitle',
        'setIsLiftigniterInit',
      ]),
      ...mapMutations([
        'setArticleListTid',
      ]),
      ...mapGetters({
        requestDomain: 'requestDomain',
        settings: 'settings',
        fetchNodeBypassSection: 'fetchNodeBypassSection',
        isLiftigniterInit: 'isLiftigniterInit',
      }),
      viewportChangeHandler() {
        if (!isDesktop()) {
          this.allowSwipePrevCard = true
          if (this.currentViewPort === 'desktop') {
            // when previous viewport is desktop then switch to mobile
            if (get(this.articleWrapper, 'scrollTop', false) && this.articleWrapper.scrollTop <= window.innerHeight) {
              // when scroll position within top card area, scroll to top
              this.articleWrapper.scrollTo(0, 0)
            }
          }
          this.currentViewPort = 'mobile'
          this.sliderOptions.disableSwipe = false
          this.showPrevCardCover = true
        } else {
          this.allowSwipePrevCard = false
          if (this.currentViewPort === 'mobile') {
            this.triggerTopCover()
          }
          this.setCoverArrowsPosition()
          this.currentViewPort = 'desktop'
          this.sliderOptions.disableSwipe = true
          this.showPrevCardCover = false
          this.resetscaleBottomCard()
        }

        const cardCover = this.getCardChild(this.activeNID)
        if (cardCover) this.bottomBlankSpace = !(cardCover.$el.offsetHeight > this.viewportHeight)
      },
      showCoverArrowsOnce(second) {
        if (this.showCoverArrowOnce) {
          this.hoverCover = true
          this.setCoverArrowsPosition()
          this.arrowVisible = true
          setTimeout(() => {
            this.arrowVisible = false
          }, second || 3000)
        }
      },
      lazyCover(index) {
        if (Math.abs(index - indexOf(this.articleList, this.activeNID)) <= 2) {
          return true
        }
        return false
      },
      forceShowArrows(direction) {
        if (direction === 'left' && indexOf(this.articleList, this.activeNID) === 0) return
        if (direction === 'right' && (indexOf(this.articleList, this.activeNID) + 1) === this.articleList.length) return
        this.hoverCover = true
        this.arrowVisible = true
        this.setCoverArrowsPosition()
      },
      forceHideArrows() {
        this.arrowVisible = false
        setTimeout(() => {
          this.hoverCover = false
        }, 200)
      },
      setCoverArrowsPosition() {
        const arrowHover = get(this, '$refs.arrowsHoverWrapper[0]')
        if (arrowHover) {
          const arrowHoverPosTop = arrowHover.querySelector('.card-middle').getBoundingClientRect().top
          if (get(this, '$refs.articleArrowLeft')) this.$refs.articleArrowLeft.style.top = `${(arrowHoverPosTop - 35) * 0.0625}rem`
          if (get(this, '$refs.articleArrowRight')) this.$refs.articleArrowRight.style.top = `${(arrowHoverPosTop - 35) * 0.0625}rem`
        }
      },
      // Share panel detection
      shareBarAndHeaderBarToggle(showHeaderText) {
        const toggleHeaderText = isBoolean(showHeaderText) ? showHeaderText : true

        if (!get(this, 'articleBody[0]', false)) return
        const newScrollPosition = this.articleWrapper.scrollTop

        this.toggleMobileHeaderText(true)

        if (isDesktop()) {
          this.desktopShareHeaderControl()
          this.lastScrollPosition = newScrollPosition
        }

        const allTags = this.articleBody[0].$el.getElementsByClassName('tags-wrapper')

        // Get the last tag-wrapper offset top
        const lastTag = last(allTags)
        const tagsWrapperOffsetTop = isDomElement(lastTag) ? Math.round(lastTag.getBoundingClientRect().top) : 0

        // Check if scroll to tags wrapper
        const InTags = ((tagsWrapperOffsetTop + this.shareButtons.offsetHeight) - window.innerHeight) <= 0

        const shareBar = this.articleBody[0].$el.getElementsByClassName('share-toolbar')[0]
        if (shareBar) {
          const shareBarOffsetTop = shareBar.getBoundingClientRect().top
          if (shareBarOffsetTop <= `-${shareBar.offsetHeight}`) {
            this.inCard = InTags
          }
          // Share panel is locating above viewport top and scrolling down
          if (shareBarOffsetTop <= `-${shareBar.offsetHeight}` && newScrollPosition > this.lastScrollPosition) {
            if (this.articleType !== 'live') {
              this.showMiniHeader()
            }
            this.toggleShareBarActive(true)
            this.lastScrollPosition = newScrollPosition

            // Check if scroll to tags wrapper
            if (InTags) {
              this.toggleShareBarActive(false)
            } else {
              this.toggleShareBarActive(true)
            }
            return
          }
        }

        // Share panel is locating below viewport top
        if (this.allowHeaderToggle) {
          if (toggleHeaderText) this.toggleShareBarActive(false)
          if (toggleHeaderText && this.articleType !== 'live' && !this.bottomCardOnScreen()) this.showHeaderText()
        }

        this.lastScrollPosition = newScrollPosition
      },

      desktopShareHeaderControl() {
        if (get(this, 'articleWrapper')) {
          const article = this.articleWrapper.getElementsByClassName('article-parent-wrapper')[0]
          const tags = this.articleWrapper.getElementsByClassName('tags-wrapper')[0]
          const articleOffsetTop = article ? article.getBoundingClientRect().top : 0
          const tagsOffsetTop = tags ? tags.getBoundingClientRect().top : 1

          this.updateReadingPosition()

          // Show desktop header when scroll between article content and tags
          if (articleOffsetTop < 0 && tagsOffsetTop > 0) {
            this.setDesktopShareHeader(true)
          } else {
            this.setDesktopShareHeader(false)
          }
        }
      },

      updateReadingPosition() {
        const article = this.articleBodyCardWrapper[0]
        const card = get(article.getElementsByClassName('card-cover'), '[0].offsetHeight', 0)
        const wrapper = get(article.getElementsByClassName('article-parent-wrapper'), '[0].offsetHeight', false)
        if (wrapper) {
          const totalHeight = card + wrapper
          const progress = Math.abs((this.articleWrapper.scrollTop / totalHeight) * 100)
          this.setDesktopReadingPosition(progress)
        }
      },
      resetShareBar() {
        this.shareButtons.style.transform = ''
        if (this.$refs.shareButtons.nativeShare) {
          this.shareBarActive = 'reset'
        } else {
          this.toggleShareBarActive(false)
        }
      },
      isActive(nid) {
        if (nid === this.activeNID) {
          return true
        }
        return false
      },
      toggleShareBarActive(value) {
        if (this.shareBarWaitForActive && this.shareBarActive === 'reset') {
          return
        }

        this.shareBarActive = (value || this.$refs.shareButtons.nativeShare) ? 'active' : 'hide'
      },
      setArticleList(list) {
        return Promise.all(map(list, nid => this.$store.dispatch('fetchNode', { nid }))).then((_result) => {
          this.articleList = list
        })
      },
      fetchArticleList(append = false, liftigniterFetch = false) {
        // First fetch, register tid
        if (!this.articleListTid) {
          this.setArticleListTid(get(this, 'lastSection.tid'))
        }
        // Set tid to whois and whatis if tid is whois or whatis
        if (this.articleListTid === '325779' || this.articleListTid === '325780') {
          this.setArticleListTid(getNodeQueueTid('whois_and_whatis'))
        }

        // If no more content, disable the fetch
        if (!this.noMoreContent && this.articleListTid) {
          let maxOfList = this.articleListLimit

          if (liftigniterFetch) {
            if (this.articleListOffset === 0) maxOfList -= 1
            // get queue from liftigniter
            const liftigniterFetchOptions = {
              excludeIds: this.articleList,
              requestFields: ['id'],
            }
            const tid = get(this, 'articleListTid', '').toString()
            if (!this.fetchNodeBypassSection() && tid !== '325163') {
              // who is & what is tid
              if (tid === '325165') {
                liftigniterFetchOptions.section = ['What is', 'Who is']
              } else if (get(this, 'lastSection.name', false)) {
                liftigniterFetchOptions.section = get(this, 'lastSection.name', false)
              }
            }
            new Promise((resolve) => {
              EventBus.$emit('liftigniter-FetchInventory', maxOfList, liftigniterFetchOptions, resolve)
            }).then((nids) => {
              const articleList = this.articleListCheck(nids, maxOfList)
              if (append) {
                this.articleListOffset += maxOfList
                this.appendArticleList(articleList)
              }
            })
          } else {
            // get queue from node queue
            this.$store.dispatch('fetchNodeQueueDynamic', {queueName: 'section_top', tid: this.articleListTid, offset: this.articleListOffset, limit: maxOfList}).then((nids) => {
              const articleList = this.articleListCheck(nids, maxOfList)
              if (append) {
                this.articleListOffset += maxOfList
                this.appendArticleList(articleList)
              }
            })
          }
        }
      },
      articleListCheck(nids, maxOfList) {
        const articleList = xor(this.articleList, values(nids))

        if (nids.length < maxOfList) {
          this.noMoreContent = true
        } else {
          this.arrowNext = true
        }

        return articleList
      },
      getWrapperRef(nid) {
        return `articleWrapper-${nid}`
      },
      getBodyCardWrapperRef(nid) {
        return `articleBodyCardWrapper-${nid}`
      },
      getCoverRef(nid) {
        return `articleCover-${nid}`
      },
      getArticleRef(nid) {
        return `articleBody-${nid}`
      },
      getCardChild(nid) {
        return get(this, `$refs[${this.getCoverRef(nid)}][0]`, false)
      },
      appendArticleList(nids) {
        return this.setArticleList(unionBy(this.articleList, nids, toInteger))
      },
      slideProgress(e) {
        this.newsLetterWidgetXPadding = get(e, 'deltaX', 0)
        this.toggleMobileHeaderText(false)
      },
      slideChangeEnd(e) {
        this.scrollEnd = true
        this.activeBottom = false
        this.setDesktopReadingPosition(0)
        if (get(e, 'response.change')) {
          const carouselSlideCount = get(e, 'response.slideCount', 0)
          const carouselCurrentSlide = get(e, 'response.activeSlide', 0) + 1
          // If reach 3 page before the end, start fetching
          if (carouselSlideCount % this.articleListLimit === 0 && carouselCurrentSlide >= carouselSlideCount - 3) {
            this.fetchArticleList(true, this.fetchNodeQueueFromLiftigniter)
          }

          // stop play previous video
          this.videoPlayerEnd(false, true)

          // Slide change by scroll
          if (this.nextBybottom) {
            // Reset position of previous item scroll.
            this.articleWrapper.scrollTop = 0
            this.lastPosition[this.activeNID] = 0
          } else {
            // Store current scroll position
            if (!this.inCard) {
              this.shareBarWaitForActive = true
              this.shareBarNoAnimation = true
              this.shareBarActive = 'hide'
            } else {
              this.shareBarNoAnimation = false
              this.toggleShareBarActive(true)
            }
            this.lastPosition[this.activeNID] = this.articleWrapper.scrollTop
          }

          this.showTopCover = true
          this.triggerTopCover()
          this.setActiveNID(this.articleList[e.response.activeSlide])
          this.actionOnCardCoverPerpareNextAnimation()
          this.updateRoute()
          this.resetShareBar()

          this.arrowNext = this.hasNext()
          // Slide change by swipe
          if (!this.nextBybottom && !isDesktop()) {
            const lastPos = this.lastPosition[this.activeNID]
            if (!lastPos) {
            // At topCover
              this.resetMobileHeader()
              return
            }
            this.inCard = false

            const shareBar = this.articleBody[0].$el.getElementsByClassName('share-toolbar')[0]
            const shareBarScrollTop = shareBar.getBoundingClientRect().top + shareBar.style.height
            // Trigger header by article last position
            if (!lastPos > shareBarScrollTop) {
              // Under share panel
              this.showMiniHeader()
              this.showTopCover = false

              this.toggleShareBarActive(true)
            } else {
              // Between topCover and sharePanel
              this.showHeaderText()
              this.showTopCover = false
            }
          } else {
            this.inCard = true
          }

          // this.actionOnCardCoverAnimation()
          this.cardCoverAfterDragIn()

          this.nextBybottom = false
          if (isDesktop()) {
            this.lastPosition[this.activeNID] = 0
            this.arrowPrev = this.hasPrev()
            this.resetArrow()
          }
        } else {
          this.shareBarAndHeaderBarToggle(false)
          if (!this.showTopCover) {
            this.inCard = false
          } else {
            this.inCard = true
          }
        }
        this.slideChanging = false
      },
      updateRoute() {
        this.$store.dispatch('fetchNode', { nid: this.activeNID }).then(() => {
          const activeNode = this.$store.getters.node(this.activeNID)
          const routeData = {
            type: activeNode.type,
            nid: activeNode.nid,
            url: activeNode.relative_url,
            title: activeNode.title,
            // This is a dummy props, where we should get node object from vuex
            props: {
              nid: activeNode.nid,
            },
          }
          this.$router.addRouteByNode({routeData})
          this.$router.push(routeData.url)
          this.cardCoverAfterDragIn()
        })
      },
      slideChangeStart(e) {
        if (this.nextBybottom) this.cardActionAnimate = true
        this.slideChanging = true
        this.disableCardAnimate = true

        if (isDesktop()) {
          this.bodyFadeIn = true
        }
        this.arrowVisible = false

        // Slide change by scroll to bottom
        if (this.nextBybottom) {
          // Slide change by swipe
          this.toggleShareBarActive(false)
          GTMManager.pushTracker({
            category: 'Perpetual Scroll',
            action: get(this, 'node.relative_url', ''),
            label: get(this, `nodes[${this.articleList[e.response.activeSlide]}].relative_url`, ''),
          })
        }
      },
      handleTouchStart(e) {
        // Specia1479l fix for Mobile Safari to remain the action bar.
        window.scrollTo(0, 0)
        /**
         * Remember the last position and timestamp for calculate movement and speed.
         * Mark currently is touching so that scroll event handler will do nothing.
         * Reset card status to make sure no animation.
         */
        this.touchStartX = e.changedTouches[0].clientX
        this.touchStartY = e.changedTouches[0].clientY
        this.touching = true
        this.touchTimeStamp = e.timeStamp
        this.bounce = false
        this.bottomCardReset = false
        this.bounceBottom = false
        this.newsLetterWidgetXPadding = 0
        this.cardReset = false
      },
      toggleTopCover() {
        const articleBody = get(this, 'articleBody[0]', false)
        if (isDomElement(articleBody.$el) && this.articleWrapper.scrollTop > articleBody.$el.offsetTop && !isDesktop()) {
          this.showTopCover = false
        }
      },
      handleTouchMove(e) {
        const moveDistanceY = e.changedTouches[0].clientY - this.touchStartY
        const moveDistanceX = e.changedTouches[0].clientX - this.touchStartX
        if (!this.sliderOptions.setScrolling) {
          this.sliderOptions.setScrolling = true
          if (Math.abs(moveDistanceY) > Math.abs(moveDistanceX)) {
            this.sliderOptions.childScrolling = true
          } else {
            this.sliderOptions.childScrolling = !this.scrollEnd
          }
          this.sliderOptions.childProcessed = ((!this.bottomDividerOnScreen() || !this.nextArticleCover) && !this.isVideoFullScreen)
          this.sliderOptions.forceStop = (this.bottomDividerOnScreen() && this.nextArticleCover)
        }
        if (!this.sliderOptions.childScrolling && !this.bottomCardOnScreen()) this.newsLetterWidgetXPadding = moveDistanceX

        if (this.sliderOptions.childScrolling) {
          // Stop scroll and also prevent pull to refresh feature in android if now at the top of the article body.
          if ((moveDistanceY > 0) && this.articleWrapper.scrollTop <= 0) {
            e.preventDefault()
          }
          // If now showing top cover, mean at the top of article body (detected by scroll).
          if (this.showTopCover && this.articleCover) {
            // Calculate how many % to be visible for the top card.
            if (!isEmpty(this.articleCover)) {
              if (moveDistanceY > 0) {
                if (get(this, 'articleCover[0].$el')) {
                  if (!isDesktop()) this.cardMargintop = (((moveDistanceY + this.articleWrapper.scrollTop) / this.articleCover[0].$el.offsetHeight) * 100) - this.viewPortHeightVh
                  this.inCard = false
                }
              }
            } else {
              if (moveDistanceY > 0) {
                this.allowHeaderToggle = true
              }
              this.inCard = true
              this.cardMargintop = 0
            }

            // Reduce headerBarTitle when scroll from body to cover
            if (moveDistanceY > 0) {
              const absMoveDistance = Math.abs(moveDistanceY)
              this.toggleHeaderBar({position: 50 - ((absMoveDistance / this.innerHeight()) * 100), animate: false})
            }
          } else {
            // Reset allowHeaderToggle if scroll up
            if (moveDistanceY > 0) {
              this.allowHeaderToggle = true
            }

            this.reachTopBottom = (moveDistanceY < 0 && this.checkAtBottom())
          }
        }
        this.toggleTopCover()
      },
      handleTouchEnd(e) {
        this.reachTopBottom = false
        if (this.scrollEnd) {
          this.sliderOptions.childProcessed = false
          this.sliderOptions.setScrolling = false
          this.sliderOptions.childScrolling = false
          this.newsLetterWidgetXPadding = 0
        }

        // Release lock for scroll handler.
        this.touching = false
        // Calculate the speed ourself, we can't use hammer with native scroll enabled.
        const speed = (this.touchStartY - e.changedTouches[0].clientY) / (this.touchTimeStamp - e.timeStamp)

        if (this.showTopCover && this.articleCover) {
          // If the cover is showing, and check if current visible area of the card / speed can be display the full card or go back to article.
          this.cardReset = true
          if ((Math.abs(this.cardMargintop) < 80 || speed > 0.6) && !this.isVideoFullScreen) {
            this.triggerTopCover()
          } else if (this.touchStartY - e.changedTouches[0].clientY < 0) {
            this.bouceBackToBodyTop()
          } else {
            this.topCovertoBody()
          }
        } else if (!this.showTopCover && this.articleWrapper.scrollTop === 0) {
          // If the top card is hidden, and now hitting the top of the wrapper, show the card and do bouncing animation.
          this.showTopCover = true
          this.atTop = true
          this.topCovertoBody()
          if (!isIOS()) {
            this.bounce = true
          }
        } else if (this.nextCard && this.nextArticleCover) {
          // If the bottom cover is showing, check again if the body is updated.
          if (!this.checkAtBottom()) {
            this.resetBottomCover()
          }

          // If the bottom cover is showing, and check if current visible area of the card / speed can be display the full card and go to next article or go back to article.
          this.bottomCardReset = true
          if (Math.abs(this.bodyMarginTop) > 40 || speed < -0.6) {
            this.nextBybottom = true
            this.bodyMarginTop = -100
            this.atTop = false
            this.showTopCover = true
            this.triggerTopCover()
            this.actionOnCardCoverAnimation()
            this.bounce = false
            this.cardReset = false
          } else {
            this.bodyMarginTop = 0
          }
        } else if (this.hasNext() && this.checkAtBottom()) {
          // Active bottom cover if at the bottom.
          this.activeBottomCover()
        }
      },
      showArrow() {
        return (((!get(this, 'articleCover[0].$el') || (this.articleWrapper.scrollTop > (this.articleCover[0].$el.offsetHeight)))) && isDesktop())
      },
      handleArrowFadeOut() {
        if (isDesktop()) {
          const articleWrapperOffsetHeight = get(this, 'articleCover[0].$el.offsetHeight')
          const bodyWrapperOffsetHeight = get(this, 'articleBodyCardWrapper[0].offsetHeight')
          const monsterNewsletterHeight = get(this, '$refs.monsterNewsletter[0].$el.offsetHeight', 0)
          if (this.bottomCardOnScreen() && articleWrapperOffsetHeight && bodyWrapperOffsetHeight) {
            let wrapperScrollPos = (articleWrapperOffsetHeight + bodyWrapperOffsetHeight) -
              get(this, 'articleWrapper.scrollTop', 0)
            if (articleWrapperOffsetHeight >= window.innerHeight) {
              wrapperScrollPos -= (articleWrapperOffsetHeight - window.innerHeight)
            }
            wrapperScrollPos -= monsterNewsletterHeight
            const arrowPos = ((window.innerHeight) + 190)
            if (wrapperScrollPos <= arrowPos) {
              const arrowTopMarginTotal = Math.abs(window.innerHeight - arrowPos)
              const crossArrowPos = arrowPos - wrapperScrollPos
              const newArrowTopPercentage = `${(arrowTopMarginTotal - crossArrowPos - 70) * 0.0625}rem`
              this.newArrowTopPercentage = {top: `${newArrowTopPercentage}`}
            } else {
              this.newArrowTopPercentage = {}
            }
          }
        }
      },
      resetArrow() {
        this.newArrowTopPercentage = {}
        this.arrowInit = false
      },
      handleWheel(e) {
        e.preventDefault()
      },
      handleScroll(e) {
        if (!this.firstScrollTimeStamp && !this.firstScrollPos) {
          this.firstScrollTimeStamp = e.timeStamp
          this.firstScrollPos = get(this, 'articleWrapper.scrollTop', 0)
        } else {
          const timestampDiff = e.timeStamp - this.firstScrollTimeStamp
          const posDiff = get(this, 'articleWrapper.scrollTop', 0) - this.firstScrollPos
          this.touchSpeed = posDiff / timestampDiff
        }
        this.scaleBottomCard()
        clearTimeout(this.scrollTimer)
        this.scrollEnd = false
        this.scrollTimer = setTimeout(() => {
          this.scrollEnd = true
          this.sliderOptions.setScrolling = false
          this.firstScrollTimeStamp = false
          this.firstScrollPos = false
          this.touchSpeed = false
        }, 100)

        const currentScrollY = get(this, 'articleWrapper.scrollTop', 0)

        if (isDesktop()) {
          if (!this.slideChanging) {
            if (get(this, '$refs.articleArrowLeft', false)) {
              if (this.showArrow()) {
                this.hoverCover = false
                this.arrowVisible = this.showArrow()
                this.arrowInit = this.showArrow()
                if (isDomElement(this.$refs.articleArrowLeft)) this.$refs.articleArrowLeft.style.top = ''
                if (isDomElement(this.$refs.articleArrowRight)) this.$refs.articleArrowRight.style.top = ''
              } else {
                this.arrowVisible = this.hoverCover
                if (this.hoverCover) {
                  this.setCoverArrowsPosition()
                }
              }
              this.handleArrowFadeOut()
            }
          }
        }

        if (currentScrollY > this.articleScrollY) {
          // scrolling up
          this.allowHeaderToggle = true
        }

        this.shareBarAndHeaderBarToggle()
        this.sliderOptions.childScrolling = true
        if (this.hasNext && this.checkAtBottom()) {
          // If bottom cover is not shown yet, and now hitting the bottom of article body, display the bottom cover.
          this.activeBottomCover()
        }

        if (!this.touching) {
          const articleBody = get(this, 'articleBody[0]', false)
          // Commented out: DISABLED NEWSLETTER POP UP until further notice
          /*
          // Only show newsletter popup in article content, not showing in card
          if (this.newsletterCheckCount < 1 && !isDesktop() && isEmpty(this.articleCover)) {
            const newsletterOffset = this.articleBodyCardWrapper[0].offsetHeight - this.articleWrapper.scrollTop
            const newsletterScrollToDetection = newsletterOffset / this.articleBodyCardWrapper[0].offsetHeight
            if (newsletterScrollToDetection <= 0.6 && !this.allowNewsletterWidgetPopup) {
              this.enableNewsletterWidgetPopup(true)
              this.newsletterCheckCount += 1
            }
          }
          */


          if (!this.showTopCover && articleBody && this.articleWrapper.scrollTop === articleBody.$el.offsetTop) {
            // If top cover is not shown yet and now hitting the top of article body, display the top cover.
            this.atTop = true
            this.showTopCover = true
            this.topCovertoBody()
            if (!isIOS()) {
              this.bounce = true
            }
            this.cardReset = false
          } else if (articleBody) {
            // Reset for top cover.
            this.atTop = false
            this.bounce = false
            // Reset for bottom cover.
            this.resetBottomCover()
          }
        }

        this.articleScrollY = currentScrollY

        if (isDesktop()) {
          if (this.articleWrapper.scrollTop < 200) {
            this.toggleHeaderTitle(true)
            this.updateDesktopHeaderTitlePosiiton(Math.abs(this.articleWrapper.scrollTop) * -1)
          } else {
            this.toggleHeaderTitle(false)
          }
        }
        this.toggleTopCover()
      },
      bindTopCoverTouchSupport() {
        if (isDesktop() && isTablet()) return
        // All event under this function will be gone anyway.
        const self = this
        // Check if element exists and no hammer binded.
        if (get(self, 'articleCover[0].$el') && !get(self, 'articleCover[0].$hammer')) {
          const Hammer = require('hammerjs')
          // Create hammer instance.
          self.articleCover[0].$hammer = new Hammer.Manager(self.articleCover[0].$el, {
            recognizers: [
              [Hammer.Pan, { direction: Hammer.DIRECTION_ALL }],
            ],
          })
          // Make sure no animation css class when touch start and record the inital position.
          self.articleCover[0].$hammer.on('panstart', (e) => {
            self.preventPan = (self.cardMargintop !== 0)
            if (self.preventPan) return
            if (!self.showTopCover) return
            self.sliderOptions.childScrolling = (e.additionalEvent === 'panup')
            if (!self.scrollEnd) self.sliderOptions.childScrolling = true
            self.cardReset = false
            self.touchStartY = e.center.y
          })
          // When touch moving change the margin top of the card to adjust how many % of the card to be visible.
          self.articleCover[0].$hammer.on('panmove', (e) => {
            if (!isDesktop()) {
              if (self.preventPan) return
              if (!this.showTopCover) return
              if (!this.isVideoFullScreen && !self.sliderOptions.setScrolling) {
                self.sliderOptions.setScrolling = true
                if (e.additionalEvent === 'panup' || e.additionalEvent === 'pandown') {
                  self.sliderOptions.childScrolling = e.additionalEvent === 'panup' || (e.additionalEvent === 'pandown' && e.angle >= 80 && e.angle <= 100)
                } else {
                  self.sliderOptions.childScrolling = !(e.additionalEvent === 'pandown' && e.angle >= 80 && e.angle <= 100) ? false : !self.scrollEnd
                }
                self.sliderOptions.childProcessed = true
              }
              if (self.sliderOptions.childScrolling && get(self, 'articleCover[0].$el', false)) {
                const move = Math.round((((e.center.y - self.touchStartY) + self.articleWrapper.scrollTop) / (self.articleCover[0].$el.offsetHeight)) * 100)
                if (move <= 0) {
                  self.toggleHeaderBar({
                    position: (Math.min(100, Math.abs(move)) * 50) / 100,
                    animate: true,
                    lock: false,
                  })
                  self.cardMargintop = move
                } else if (self.allowSwipePrevCard && self.prevArticleNID) {
                  self.prevCardMargintop = (self.viewportHeight * -1) + e.deltaY
                  self.cardMargintop = 0
                }
              }
            }
          })
          // When touchend, detect visiable area of the card and speed of the swipe action.
          self.articleCover[0].$hammer.on('panend', (e) => {
            if (!isDesktop()) {
              if (self.preventPan) return
              if (!this.showTopCover) return
              self.sliderOptions.childProcessed = false
              self.sliderOptions.setScrolling = false
              self.scrollEnd = false
              if (self.sliderOptions.childScrolling) {
                self.cardReset = true
                const triggerPointOfBackToCard = 100 * 0.10
                if ((Math.abs(self.cardMargintop) > triggerPointOfBackToCard || (e.additionEvent === 'panup' && e.velocityY < -0.8)) && !isDesktop()) {
                  self.prevCardMargintop = (self.viewportHeight * -1)
                  if (self.cardCoverIsVideo && self.scaleHeaderBar <= 0) {
                    self.topCovertoBody()
                  } else if (Math.abs(self.cardMargintop) <= 100) {
                    self.topCovertoBody()
                  }
                } else if (!isDesktop() && self.allowSwipePrevCard && self.prevArticleNID && ((e.deltaY / self.viewportHeight > 0.2) || (e.velocityY > 0.8 && e.deltaY > 0))) {
                  self.prevCardMargintop = (self.viewportHeight - (self.viewportHeight * (self.viewPortHeightVh / 100))) * -1
                  self.lastPosition[self.prevArticleNID] = 0
                  setTimeout(() => {
                    self.$refs.cusCarousel.prev(false)
                  }, 350)
                } else {
                  self.triggerTopCover()
                }
                setTimeout(() => {
                  self.preventPan = false
                }, 400)
              }
            } else {
              self.sliderOptions.childProcessed = true
            }
          })
        }
      },
      bindVidoeCardConatinerTouchSupport() {
        if (!isDesktop()) {
          const videoCardContainer = get(this, 'cardVideoContainer[0]', false)
          if (videoCardContainer && !get(videoCardContainer, 'touchInit', false)) {
            videoCardContainer.touchInit = true
            const passive = supportPassive() ? { passive: true } : false
            videoCardContainer.addEventListener('touchstart', this.handleTouchStart, passive)
            videoCardContainer.addEventListener('touchmove', this.handleTouchMove)
            videoCardContainer.addEventListener('touchend', this.handleTouchEnd, passive)
          }
        }
      },
      bindBodyTouchSupport() {
        const articleBody = get(this, 'articleBody[0]', false)
        if (articleBody && !get(articleBody, 'touchInit', false)) {
          articleBody.touchInit = true
          const passive = supportPassive() ? { passive: true } : false
          if (get(this, '$root.appBrowser') === 'safari' && get(this, '$root.appOs') === 'macOs') {
            this.articleWrapper.addEventListener('scroll', throttle(this.handleScroll, 300), passive)
          } else {
            this.articleWrapper.addEventListener('scroll', this.handleScroll, passive)
          }
          articleBody.$el.addEventListener('touchstart', this.handleTouchStart, passive)
          articleBody.$el.addEventListener('touchmove', this.handleTouchMove)
          articleBody.$el.addEventListener('touchend', this.handleTouchEnd, passive)
        }
      },
      bindBottomCoverTouchSupport() {
        const articleWrapper = get(this, '$refs.articleBottomCardWrapper[0]', false)
        if (articleWrapper && !get(articleWrapper, 'touchInit', false)) {
          articleWrapper.touchInit = true
          const passive = supportPassive() ? { passive: true } : false
          articleWrapper.addEventListener('touchstart', this.handleTouchStart, passive)
          articleWrapper.addEventListener('touchmove', this.handleTouchMove)
          articleWrapper.addEventListener('touchend', this.handleTouchEnd, passive)
        }
      },
      checkAtBottom(offset = 0) {
        const articleBody = this.articleBody
        const articleBodyWrapperOffsetHeight = get(this, 'articleBodyCardWrapper[0].offsetHeight', 0)
        const articleCoverWrapperOffsetHeight = get(this, 'articleCover[0].$el.offsetHeight', 0)
        const articleWrapperScrollTop = get(this, 'articleWrapper.scrollTop', 0)
        if (isDesktop()) {
          if ((articleBodyWrapperOffsetHeight + articleCoverWrapperOffsetHeight) - articleWrapperScrollTop <= document.body.clientHeight) {
            return true
          }
        } else {
          const diffOfBodyAndArticleWrapper = articleBodyWrapperOffsetHeight - articleWrapperScrollTop
          if (!isIOS()) {
            if (this.articleBodyCardWrapper && diffOfBodyAndArticleWrapper === document.body.clientHeight) {
              return true
            }
            if (this.touching && this.nextCard && diffOfBodyAndArticleWrapper - offset >= document.body.clientHeight) {
              return true
            }
          } else {
            // to handle some in app browser bug, card height not consist with body height (eg. twitter)
            const height = (document.body.clientHeight === this.articleWrapper.offsetHeight) ? document.body.clientHeight : window.innerHeight
            if (articleBody && this.articleBodyCardWrapper && diffOfBodyAndArticleWrapper === height) {
              return true
            }
            if (this.touching && this.nextCard && diffOfBodyAndArticleWrapper - offset >= height) {
              return true
            }
          }
          return false
        }
        return false
      },
      resetBottomCover() {
        this.bodyMaxHeight = 'auto'
        this.bodyMarginTop = 0
        this.nextCard = false
        this.bounceBottom = false
      },
      activeBottomCover() {
        if (this.isCardMounted && this.isBodyMounted && this.showBottomCover && this.allowNextByBottom && this.hasNext()) {
          if (this.showNodeBody) {
            this.isCardMounted = false
            this.isBodyMounted = false
            if (!this.listenWheel) {
              this.$refs.articlePage.addEventListener('wheel', this.handleWheel)
              this.listenWheel = true
            }

            setTimeout(() => {
              if (this.videoCard && isFunction(this.videoCard.resetCardVideo)) this.videoCard.resetCardVideo()
              this.preventScroll = true
              this.pageScroll = false
              if (isDesktop()) this.showNodeBody = false
              this.sliderOptions.childScrolling = true
              this.bottomCardReset = true
              this.bodyMaxHeight = `${get(this, 'articleBodyCardWrapper[0].offsetHeight', 0)}px`
              if (this.nextArticleCover) this.nextBybottom = true
              if (has(this.$refs, 'cusCarousel.next')) this.$refs.cusCarousel.next(false)
              this.nextCard = true
              if (!isIOS()) {
                this.bounceBottom = true
              }
            }, 0)

            setTimeout(() => {
              this.pageScroll = true
              this.showNodeBody = true
              if (get(this, 'articleWrapper.classList')) this.preventScroll = false
              if (get(this, '$refs.articlePage')) this.$refs.articlePage.removeEventListener('wheel', this.handleWheel)
              this.listenWheel = false
            }, 1200)
          }
        }
      },
      topCovertoBody() {
        if (this.showTopCover) {
          this.allowHeaderToggle = true
          this.lastPosition = {}
          this.cardReset = true
          this.inCard = false
          this.shareBarNoAnimation = false
          setTimeout(() => {
            this.scrollEnd = true
          }, 300)
          this.cardMargintop = this.viewPortHeightVh * -1
          this.showHeaderText()

          GTMManager.pushTracker({
            category: 'Scroll Card',
            action: 'Scroll Card/Scroll down',
            label: 'Scroll Card',
          })
        }
      },
      bouceBackToBodyTop() {
        this.allowHeaderToggle = true
        this.lastPosition = {}
        setTimeout(() => {
          this.inCard = false
        }, 300)
        this.cardMargintop = this.viewPortHeightVh * -1
        this.toggleHeaderBar({position: 50})
      },
      triggerTopCover() {
        this.cardCoverAfterDragIn(true)
        this.inCard = true
        this.cardMargintop = 0
        this.cardAnimate = true
        // reset prev card margin top
        this.prevCardMargintop = this.viewportHeight * -1
        this.resetMobileHeader()

        if (!this.disableCardAnimate) {
          this.actionOnCardCoverAnimation()
        } else {
          this.disableCardAnimate = false
        }
        this.cardAnimate = false
      },
      remainPosition(nid) {
        if (get(this, `lastPosition[${nid}]`) > 0 && !isDesktop()) {
          return true
        }
        return false
      },
      playVideo(isFullScreen) {
        if (!isEmpty(this.videoCard)) get(this, 'videoCard.playVideo')(isFullScreen)
      },
      hideVideo() {
        this.isShowVideo[this.activeNID] = false
      },
      stopVideo() {
        if (!isEmpty(this.videoCard)) get(this, 'videoCard.stopVideo')()
      },
      videoPlayerEnd(toBody, stopVideo) {
        const cardCover = this.getCardChild(this.activeNID)
        if (cardCover) {
          if (isDesktop()) {
            this.isShowVideo[this.activeNID] = false
            this.showVideoPlayButton = true
          }
          if (stopVideo) this.stopVideo()
        }
        if (toBody) this.topCovertoBody()
      },
      cardCoverAfterDragIn(fromArticleBody) {
        if (this.cardCoverIsVideo) {
          if (isDesktop()) {
            this.isShowVideo[this.activeNID] = false
            this.showVideoPlayButton = true
          } else {
            this.isShowVideo[this.activeNID] = true
            this.showVideoPlayButton = true
            if (fromArticleBody) this.stopVideo()
          }
        } else {
          this.isShowVideo[this.activeNID] = false
        }
      },
      actionOnCardCoverAnimation() {
        const cardCover = this.getCardChild(this.activeNID)
        if (cardCover) { cardCover.showCardAnimation() }
      },
      actionOnCardCoverPerpareNextAnimation() {
        const cardCover = this.getCardChild(this.activeNID)
        if (cardCover) { cardCover.hideAnimationElement() }
      },
      actionOnVideoFullScreen(event) {
        if (!get(event, 'isDesktop', false) && get(event, 'isPreviousFullScreen') && !get(event, 'isFullScreen')) {
          this.videoPlayerEnd(true, false)
          this.isVideoFullScreen = false
          this.sliderOptions.childProcessed = true
          this.sliderOptions.showAnimation = undefined
        } else {
          this.sliderOptions.showAnimation = false
          this.sliderOptions.childProcessed = false
          this.isVideoFullScreen = true
          this.enableLandscapeBlock(false)
        }
      },
      actionOnVideoIdle(event) {
        if (get(event, 'isDesktop', false)) {
          this.hideVideoOnDesktop(get(event, 'isOnComplete', false))
        } else {
          this.videoPlayerEnd(false)
        }
      },
      actionOnVideoPause(event) {
        if (!get(event, 'isDesktop', false)) {
          this.videoPlayerEnd(false)
        }
      },
      actionOnVideoPlay() {
        this.isShowVideo[this.activeNID] = true
        if (isDesktop()) {
          this.showVideoPlayButton = false
          this.hideVideoPromise = undefined
          this.actionOnCardCoverPerpareNextAnimation()
        }
      },
      hideVideoOnDesktop(delay) {
        if (!this.hideVideoPromise) {
          const handleCardAnimation = () => {
            this.actionOnCardCoverAnimation()
            const cardCover = this.getCardChild(this.activeNID)
            if (cardCover) {
              this.isShowVideo[this.activeNID] = false
              this.showVideoPlayButton = true
            }
          }

          if (delay) {
            this.hideVideoPromise = new Promise((resolve) => {
              setTimeout(() => {
                if (this.hideVideoPromise) {
                  handleCardAnimation()
                  resolve(true)
                }
              }, 2000)
            })
            this.hideVideoPromise.then(() => {
              this.hideVideoPromise = undefined
            })
          } else {
            handleCardAnimation()
          }
        }
      },
      actionOnVideoHide() {
        this.hideVideoOnDesktop(false)
      },
      bottomCardOnScreen() {
        const articleCoverOffsetHeight = get(this, 'articleCover[0].$el.offsetHeight', 0)
        const articleBodyCardWrapperOffsetHeight = get(this, 'articleBodyCardWrapper[0].offsetHeight', 0)
        if (isDesktop()) {
          // for desktop
          let calScroll = ((articleCoverOffsetHeight + articleBodyCardWrapperOffsetHeight) -
          get(this, 'articleWrapper.scrollTop', 0))
          if (articleCoverOffsetHeight >= window.innerHeight) {
            calScroll -= (articleCoverOffsetHeight - window.innerHeight)
          }
          if (get(this, 'articleCover[0].$el') && (calScroll < (window.innerHeight * 2))) {
            return true
          }
        } else {
          // for mobile
          if (articleBodyCardWrapperOffsetHeight - get(this, 'articleWrapper.scrollTop', 0) <
            (window.innerHeight * 2)) {
            return true
          }
          return false
        }
        return false
      },
      bottomDividerOnScreen() {
        const bottomDivider = get(this, '$refs.bottomDivider[0]')
        if (isDomElement(bottomDivider)) {
          return (bottomDivider.getBoundingClientRect().top < window.innerHeight)
        }
        return false
      },
      scaleBottomCard() {
        if (isDesktop()) return
        if (this.bottomDividerOnScreen()) this.sliderOptions.forceStop = true
        const bottomCardRef = this.getCoverRef(this.nextArticleNID)
        const bottomCardHeight = get(this, `$refs[${bottomCardRef}][0].$el.offsetHeight`)
        if (this.showBottomCover && this.bottomCardOnScreen() && bottomCardHeight) {
          this.allowNextByBottom = true
          const articleBodyCardWrapperOffsetHeight = get(this, 'articleBodyCardWrapper[0].offsetHeight', 0)
          const calScale = this.initBottomCardScale + ((1 - (Math.abs(articleBodyCardWrapperOffsetHeight - get(this, 'articleWrapper.scrollTop', 0) - window.innerHeight) / window.innerHeight)) * (1 - this.initBottomCardScale))
          this.bottomCardScale = calScale <= 1 ? calScale : 1
          // little bit laggy on android, add some transition to make it more smooth
          if (/Android/.test(navigator.appVersion)) this.bottomCardSmoothAnimate = true
        }
        if (this.checkAtBottom()) this.showBottomCover = true
      },
      resetscaleBottomCard() {
        if (!isDesktop()) {
          this.showBottomCover = false
          this.allowNextByBottom = false
          this.bottomCardScale = 0.3
          this.bottomCardSmoothAnimate = false
          this.firstScrollTimeStamp = false
          this.firstScrollPos = false
          this.touchSpeed = false
        } else {
          this.showBottomCover = true
          this.allowNextByBottom = true
          this.bottomCardScale = 1
        }
      },
      videoAutoStart() {
        return isDesktop()
      },
      handleViewportChange() {
        window.addEventListener('resize', this.viewportChangeHandler)
      },
      prevArticle() {
        this.nextPrevByArrow = true
        if (has(this.$refs, 'cusCarousel.prev')) this.$refs.cusCarousel.prev(true)
        this.resetDesktopHeader()
        if (this.videoCard) this.videoCard.resetCardVideo()
      },
      nextArticle() {
        this.nextPrevByArrow = true
        if (has(this.$refs, 'cusCarousel.next')) this.$refs.cusCarousel.next(true)
        this.resetDesktopHeader()
        if (this.videoCard) this.videoCard.resetCardVideo()
      },
      cardMounted(nid) {
        // use `cardMounted` instead of updated state coz updated state is not promise top cover rendered
        if (nid === this.activeNID) {
          if (!isDesktop()) this.resetscaleBottomCard()
          if (this.cardActionAnimate) {
            this.getCardChild(this.activeNID).cardActionAnimate()
          }
          this.sliderOptions.forceStop = false
          this.isCardMounted = true
          const cardCover = this.getCardChild(this.activeNID)
          if (cardCover) this.bottomBlankSpace = !(cardCover.$el.offsetHeight > this.viewportHeight)
          if (cardCover) this.bindAnimation(cardCover.$el, [this.checkCardReset])
          unbindInputForAndroid(this.articleWrapper)
          bindInputForAndroid(this.articleWrapper)
          this.allowHeaderToggle = false
          if (this.showTopCover && get(this, `$refs[${this.getCoverRef(this.activeNID)}][0].$el`)) {
            this.bindTopCoverTouchSupport()
            this.bindBodyTouchSupport()
            this.bindBottomCoverTouchSupport()
            this.bindVidoeCardConatinerTouchSupport()
          }

          if (this.scrollToTopFlag) {
            this.scrollToTopFlag = false

            if (get(this, 'articleWrapper.scrollTop', false)) {
              this.articleWrapper.scrollTop = 0 // IE: use scrollTop
            }
          }
        }
      },
      bodyMounted() {
        this.isBodyMounted = true
      },
      resetArticleView() {
        this.showTopCover = true
        this.$refs.cusCarousel.goTo(0)
        this.triggerTopCover()
        this.resetDesktopHeader()
        this.resetMobileHeader()
        this.arrowNext = this.articleList > 0
        this.scrollToTopFlag = true
      },
      hasNext(nid) {
        if (!nid) {
          return ((indexOf(this.articleList, this.activeNID) + 1) < this.articleList.length)
        }
        return ((indexOf(this.articleList, nid) + 1) < this.articleList.length)
      },
      hasPrev(nid) {
        if (!nid) {
          return ((indexOf(this.articleList, this.activeNID) + 1) > 1)
        }
        return ((indexOf(this.articleList, nid) + 1) > 1)
      },
      refreshToRoutedArticle(routeNid, routeTid) {
        if (routeNid) {
          this.noMoreContent = false
          this.$store.dispatch('fetchNode', { nid: routeNid }).then(() => {
            this.setActiveNID(routeNid)
            this.articleListOffset = 0
            this.articleList = [routeNid]

            // Set TID before fetchArticleList if not the same as the current one or set it when clicking on the link so fetchArticleList can get the correct list
            if (routeTid && routeTid !== this.articleListTid) {
              this.$store.commit('setArticleListTid', routeTid)
            }

            this.fetchArticleList(true, this.fetchNodeQueueFromLiftigniter)
            this.resetArticleView()
          })
        }
      },
    },
    watch: {
      articleList() {
        if (!this.sliderOptions.initFromMount) {
          this.sliderOptions.initFromMount = true
          this.$refs.cusCarousel.init()
        }
      },
      sections() {
        this.setHeaderTitle(get(this, 'firstSectionLineage', []))
      },
      $route() {
        const routeProps = get(this, '$route.matched[0].props.default', {})
        const routeNid = get(routeProps, 'nid', false)
        const routeTid = get(routeProps, 'destinationTid', false)

        if (this.isRefreshedToRoutedArticle) {
          this.$store.commit('setIsRefreshedToRoutedArticle', false)
          this.refreshToRoutedArticle(routeNid, this.articleListTid ? this.articleListTid : routeTid)
          return
        }

        if (routeNid && this.node.nid !== routeNid) {
          const oldArticleIndex = indexOf(this.articleList, this.node.nid)
          const articleIndex = indexOf(this.articleList, routeNid)

          // Article INSIDE NodeQueue, slide to the article
          if (articleIndex !== -1) {
            // Only add animation when it is next slide or prev slide
            const isAnimated = Math.abs(articleIndex - oldArticleIndex) === 1
            this.$refs.cusCarousel.goTo(articleIndex, isAnimated)
            this.resetDesktopHeader()
            this.$refs.cusCarousel.updateSlideCount()
          } else {
            // If not in NodeQueue, needs to refresh since it will not go to the link
            this.refreshToRoutedArticle(routeNid, routeTid)
          }
        }
        EventBus.$emit('liftigniter-ResetPageview')
      },
    },
    beforeDestroy() {
      unbindInputForAndroid(this.articleWrapper)
    },
    destroyed() {
      if (this.allowNewsletterWidgetPopup) {
        this.enableNewsletterWidgetPopup(false)
      }
      window.removeEventListener('resize', this.viewportChangeHandler)
      this.setArticleListTid(false)
      this.resetDesktopHeader()
      this.resetMobileHeader()
    },
  }
</script>
<style lang="scss">
  .article-carousel {
    .no-article-gutter-mobile{
      @include respond-to('mobile') {
        margin-left: - rem-calc($mobile-article-gutter);
        margin-right: - rem-calc($mobile-article-gutter);
      }
    }
    .no-article-gutter-desktop {
      @include respond-to('desktop') {
        margin-left: rem-calc(-$mobile-article-gutter);
        margin-right: rem-calc(-$mobile-article-gutter);
      }
    }

    &.has-slider {
      .slider-pagination {
        top: 0;
        position: fixed;
        z-index: 1030;
        height: rem-calc(3);
        font-size: 0;
        padding-top: rem-calc(6);
        & > div {
          @include respond-to('desktop'){
            width: rem-calc(5);
            height: rem-calc(5);
          }
          @include respond-to('mobile'){
            width: rem-calc(3);
            height: rem-calc(3);
          }
          margin: 0;
          box-shadow: none;
          background: $white;
          opacity: 0.5;
          font-size: 0;
          &.is-active {
            opacity: 1;
          }
          & ~ div {
            @include respond-to('desktop'){
              margin-left: rem-calc(9);
            }
            @include respond-to('mobile'){
              margin-left: rem-calc(6);
            }
          }

        }
      }
    }

    @include respond-to('mobile') {
      .card-video-container {
        .card-video {
          .video-player {
            position: relative;
            width: 100%;
            display: block;
            padding: 70px 27px 0px 27px;
          }
        }
      }
    }
    .article-body-card-wrapper {
      user-select: text;

      &.with-card-video {
        background-color: $black;
        .node-type-article {
          .article-header-wrapper {
            .article-header {
              padding-top: rem-calc(24);
            }
          }
        }
      }
    }
  }
</style>
<style lang="scss" scoped>

  .articleView{
    &__shareButtons{
      position: fixed;
      top: var(--window-height, 100vh);
      z-index: 100;
      left: 0;
      transition: transform 0ms;

      &.active {
        transition: transform 400ms;
        transform: translateY(-50px);
      }

      &.hide {
        transition: transform 400ms;
        transform: translateY(50px);
      }

      &:not(.share-button-native-container) {
        &.inCard {
          transform: translateY(50px);
        }
      }

      &.share-button-native-container {
        right: rem-calc(16);
        bottom: rem-calc(20);
        transform: translateY(0px);
        left: inherit;
        top: inherit;
        &.hide {
          transform: translateY(85px) !important;
        }
        &.reset {
          transition: transform 400ms;
        }
        &.inCard {
          transition: transform 0ms;
          transform: translateY(85px) !important;
          &.active {
            transition: transform 400ms;
          }
        }
      }
      &.no-animation{
        transition: transform 0ms !important;
      }
    }
  }
  .next-article-indication {
    background-color: $white;
    position: relative;
    .coming-next {
      text-align: center;
      color: $rose;
      font-family: $silkscreen;
      font-size: rem-calc(24);
      font-weight: bold;
      line-height: rem-calc(25);
    }

    .bottom-card-invader {
      padding-top: rem-calc(8);
      display: flex;
      justify-content: center;
      svg {
        fill: $rose;
      }
    }
  }

  .article-bottom-card-wrapper {
    position: relative;
    @include respond-to('desktop') {
      height: 100vh;
      height: var(--window-height, 100vh);
      max-height: 100vh;
      .fullHeight {
        height: 100vh;
      }
    }
    @include respond-to('mobile') {
      background-color: $white;
      .smooth-animate {
        transition-duration: 100ms;
      }
    }
  }
  .article-view-wrapper {
    overscroll-behavior-y: contain;
    background-color: $white;
    height: 100vh;
    height: var(--window-height, 100vh);
    overflow-y: auto;
    touch-action: pan-y;
    -webkit-overflow-scrolling: touch;
    &.preventScroll{
      overflow-y: hidden;
    }

    .arrow-down-wrapper{
      background-color: $white;
      position: relative;
      text-align: center;
      padding: rem-calc(0 0 40 0);
      svg{
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-name: arrow-down-animation;
        fill: $rose;
      }

      &.opinion{
        background-color: $opinion-grey;
        @include respond-to('mobile') {
          background-color: $white;
        }
      }

      &.video,
      &.photo-essay{
        background-color: $black;
        @include respond-to('mobile') {
          background-color: $white;
        }
      }
      @include respond-to('mobile') {
        .bottom-divider {
          width: 100vw;
          border-bottom: rem-calc(3) solid $rose;
          margin-bottom: rem-calc(20);
        }
        padding: rem-calc(0 0 20 0);
        background-color: $white;
      }
    }

    @keyframes arrow-down-animation {
      from {
        transform: translateY(rem-calc(0));
      }

      50% {
        transform: translateY(rem-calc(10));
      }

      100% {
        transform: translateY(rem-calc(0));
      }
    }
  }
  .news-title {
    position: absolute;
    font-size: rem-calc(200);
    z-index: -999;
  }
  .card-cover {
    color: $black;

    &.cardInvisible{
      display: block;
    }

    .arrowsHover{
      position: absolute;
      top:0;
      width:inherit;
      height: inherit;
      display: flex;
      flex-direction: row;
      flex: 3;
      .center-area{
        flex: auto;
        height: 100%;
      }
      .left-area{
        width: rem-calc(400);
        height: 100%;
      }
      .right-area{
        width: rem-calc(400);
        height: 100%;
      }
      .card-middle{
        width: 100vw;
        height: 1px;
        position: absolute;
        top: 50%;
      }
    }
  }
  .card-cover.reset, .card-cover.animate {
    transition: margin 0.5s;
  }
  .card-cover.to-top {
    margin-top: -100vh;
    margin-top: calc(var(--window-height, 100vh) * -1);
  }
  .card-cover.to-top.bounce {
    animation: bounce-in 0.5s;
  }

  .node-body.bounce-bottom {
    animation: bounce-bottom 0.5s;
  }

  @keyframes bounce-bottom {
    0% {
      margin-top: 0vh;
    }
    50% {
      margin-top: -20vh;
    }
    100% {
      margin-top: 0vh;
    }
  }

  @keyframes bounce-in {
    0% {
      margin-top: -100vh;
      margin-top: calc(var(--window-height, 100vh) * -1);
    }
    50% {
      margin-top: -70vh;
    }
    100% {
      margin-top: -100vh;
      margin-top: calc(var(--window-height, 100vh) * -1);
    }
  }

  .article-body-card-wrapper {

    // Not sure whats the use of this but I need them disable for now
    // overflow: hidden;
    .reset {
      transition: 0.5s;
    }
  }

  .resetBottom {
    animation-name: bottom-bounce-in;
    animation-duration: 0.5s;
  }

  @keyframes bottom-bounce-in {
    50% { transform: translateY(-20%) }
    100% {  transform: translateY(0%)  }
  }
  .article-card-headerbar {
    height: rem-calc(50);
    width: 100%;
    background: $oxford-blue;
    opacity: .8;
    z-index: 1030;
    position: absolute;
    top: 0;
    left: 0;
  }
  .header_text {
    margin-top: rem-calc(25);
    width: 100%;
    position: absolute;
    z-index: 1031;
    top: 0;
    left: 0;
    text-align: center;
  }

  .card-video-container{
    background-color: $black;
  }

  .fixed-bottom{
    .newsletter{
      position: relative;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }

  .article-arrow{
    @include respond-to('mobile') {
      display: none;
    }
    fill: rgba(204, 204, 204, .5);
    position: fixed;
    top: rem-calc(120);
    cursor: pointer;
    z-index: 1;
    @include respond-to('desktop') {
      &.onCover {
        position: absolute !important;
        top: 0;
        fill: rgba(255, 255, 255, .9);
      }
    }
  }

  .arrow-prev{
    transform: translateX(-150%);
    left: 1%;
    &.arrowFadeIn{
      animation-name: arrow-prev-fadeIn;
      animation-duration: 0.5s;
      transform: translateX(0);
    }
    animation-name: arrow-prev-fadeOut;
    animation-duration: 0.5s;
  }

  .arrow-next{
    right: 1%;
    transform: translateX(150%);
    &.arrowFadeIn{
      animation-name: arrow-next-fadeIn;
      animation-duration: 0.5s;
      transform: translateX(0);
    }
    animation-name: arrow-next-fadeOut;
    animation-duration: 0.5s;
  }

  .related-person-overlay-header,
  .related-person-overlay {
    &.theme-desktop.showing-desktop-header {
      margin-top: rem-calc(68);
    }
  }
  .related-person-overlay-layer {
    width: 100vw;
    height: 100vh;
    height: var(--window-height, 100vh);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1198;
  }
  .related-person-overlay {
    position: absolute;
    height: 100vh;
    height: var(--window-height, 100vh);
    width: 100vw;
    top: 0;
    right: 0;
    z-index: 1199;

    transition: transform .4s ease .02s;
    overflow-y:  scroll;
    -webkit-overflow-scrolling: touch;

    @include respond-to('mobile') {
      //transform: translateX(0);
      width: 100vw;
    }
    @include respond-to('desktop') {
      //transform: translateX(0);
      width: 640px;
    }
  }
  .related-person-overlay-sharebar {
    z-index: 1200;
  }
  .hidden-right {
    transform: translateX(100vw);
  }

  @keyframes arrow-prev-fadeIn{
    0% {opacity:0; transform: translateX(-150%);}
    100% {opacity: 1; transform: translateX(0%)}
  }

  @keyframes arrow-next-fadeIn{
    0% {opacity:0; transform: translateX(150%)}
    100% {opacity: 1; transform: translateX(0%);}
  }

  @keyframes arrow-prev-fadeOut{
    0% {opacity: 1; transform: translateX(0%);}
    100% {opacity: 0; transform: translateX(-150%);}
  }

  @keyframes arrow-next-fadeOut{
    0% {opacity: 1; transform: translateX(0%);}
    100% {opacity: 0; transform: translateX(150%);}
  }

  @keyframes scroll-down-arrow {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(rem-calc(20));
    }
    100% {
      transform: translateY(0);
    }
  }

  @include respond-to('desktop') {
    .bottom-card-cover-blank-space {
      height: calc(100vh - 56.25vw);
      background-color: white;
      overflow: hidden;
      .scroll-to-continue{
        color: rgba(170, 170, 170, 1);
        text-align: center;
        font-family: $barlow;
        font-size: rem-calc(28);
        font-weight: bold;
        padding: rem-calc(28 0 12 0);
      }
      .scroll-down-arrow {
        text-align: center;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-name: scroll-down-arrow;
        svg {
          width: rem-calc(32);
          height: rem-calc(30);
          fill: rgba(153, 153, 153, 1);
        }
      }
    }
  }

  @keyframes body-fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .bodyFadeIn{
    opacity: 1;
    animation-name: body-fade-in;
    animation-duration: 1s;
  }

  .prevCardCover {
    width: 100vw;
    /*height: 100vh;*/
    overflow: hidden;
    transfrom: translateY(11vh);
    &.reset {
      transition: margin 0.5s;
    }
  }
</style>



// WEBPACK FOOTER //
// ArticleView.vue?56ffd3f5